"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.captureCollapsePrefs = exports.applyCollapsePrefs = exports.saveTimelinePrefs = exports.loadTimelinePrefs = exports.normalizePlane = exports.fmtLocal = exports.buildHourTicks = exports.layoutLanes = void 0;
function layoutLanes(spans, windowStart, windowEnd) {
    var items = spans.slice().sort(function (a, b) { return (a.start - b.start) || (a.end - b.end); });
    var lanes = [];
    var total = windowEnd - windowStart || 1;
    items.forEach(function (sp) {
        if (sp.end <= sp.start)
            return;
        var placed = false;
        for (var i = 0; i < lanes.length; i++) {
            var lane = lanes[i];
            var last = lane[lane.length - 1];
            if (!last || last.end <= sp.start) {
                lane.push(applyLayout(sp, windowStart, total));
                placed = true;
                break;
            }
        }
        if (!placed) {
            lanes.push([applyLayout(sp, windowStart, total)]);
        }
    });
    return lanes;
}
exports.layoutLanes = layoutLanes;
function applyLayout(sp, winStart, total) {
    var leftPct = ((sp.start - winStart) / total) * 100;
    var widthPct = ((sp.end - sp.start) / total) * 100;
    return __assign(__assign({}, sp), { leftPct: clampPct(leftPct), widthPct: clampPct(widthPct <= 0 ? 0.2 : widthPct) });
}
function clampPct(v) { return Math.max(0, Math.min(100, v)); }
function buildHourTicks(windowStart, windowEnd) {
    var out = [];
    var total = windowEnd - windowStart || 1;
    var hourMs = 3600000;
    var hours = Math.ceil(total / hourMs);
    for (var h = 0; h <= hours; h++) {
        var t = windowStart + h * hourMs;
        if (t > windowEnd)
            break;
        var pct = ((t - windowStart) / total) * 100;
        if (pct < 0 || pct > 100)
            continue;
        var d = new Date(t);
        var label = ('0' + d.getHours()).slice(-2) + ':00';
        out.push({ pct: pct, label: label });
    }
    return out;
}
exports.buildHourTicks = buildHourTicks;
function fmtLocal(ms) {
    var d = new Date(ms);
    var pad = function (n) { var s = '' + n; return s.length < 2 ? '0' + s : s; };
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
}
exports.fmtLocal = fmtLocal;
// Plane normalization (mirrors controller logic)
function normalizePlane(p) {
    if (!p)
        return '';
    var x = p.toLowerCase();
    if (x.indexOf('sess') === 0)
        return 'Session';
    if (x.indexOf('activ') === 0)
        return 'Activity';
    if (x.indexOf('trav') === 0)
        return 'Travel';
    if (x.indexOf('break') === 0)
        return 'Break';
    return p;
}
exports.normalizePlane = normalizePlane;
var DEFAULT_KEY = 'audroam.timeline.prefs.v1';
function loadTimelinePrefs(storage, key) {
    if (key === void 0) { key = DEFAULT_KEY; }
    try {
        var raw = storage.getItem(key);
        if (raw) {
            var parsed = JSON.parse(raw);
            if (parsed && typeof parsed === 'object' && parsed.collapse)
                return { collapse: parsed.collapse };
        }
    }
    catch (_a) { }
    return { collapse: {} };
}
exports.loadTimelinePrefs = loadTimelinePrefs;
function saveTimelinePrefs(storage, prefs, key) {
    if (key === void 0) { key = DEFAULT_KEY; }
    try {
        storage.setItem(key, JSON.stringify(prefs));
    }
    catch (_a) { }
}
exports.saveTimelinePrefs = saveTimelinePrefs;
function applyCollapsePrefs(bands, prefs) {
    if (!bands || !prefs || !prefs.collapse)
        return;
    for (var i = 0; i < bands.length; i++) {
        var b = bands[i];
        if (b && b.name && typeof prefs.collapse[b.name] === 'boolean') {
            b._collapsed = !!prefs.collapse[b.name];
        }
    }
}
exports.applyCollapsePrefs = applyCollapsePrefs;
function captureCollapsePrefs(bands) {
    var out = { collapse: {} };
    if (!bands)
        return out;
    for (var i = 0; i < bands.length; i++) {
        var b = bands[i];
        if (b && b.name)
            out.collapse[b.name] = !!b._collapsed;
    }
    return out;
}
exports.captureCollapsePrefs = captureCollapsePrefs;
